import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { Col, Form, Row } from "react-bootstrap";

import {
  emptyString,
  customerSurveyConstants,
  customerSurveyLabels,
} from "../../../constants";
import NextButton from "./shared/nextButton";
import QuestionHeadingLogo from "./shared/questionHeadingLogo";
import CustomerInfoCard from "./shared/customerInfoCard";

const { TEXTAREA_ROWS, FIRST_QUESTION_ORDER } = customerSurveyConstants;

const Textbox = (props) => {
  const {
    question,
    brandDetail,
    questionArray,
    customerDetail,
    currentQuestion,
    handleNextButton,
    handleBackButton,
    handleSubmitSurvey,
    setSurveyCompleted,
    setCustomerQuestions,
    isAllStarRatingAnswersPositive,
  } = props;

  const { charLimit, questionText, questionOrder } = question || {};

  const {
    register,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm();

  //Initial states
  const [primaryTextArea, setPrimaryTextArea] = useState(
    question?.answer || emptyString,
  );

  //Handle next button
  const handleNext = (event) => {
    event.preventDefault();

    //If primary textarea charLimit is greater the given then unable to show next question
    if (primaryTextArea.length <= charLimit) {
      const updatedQuestions = (questionArray || []).map((questionItem) => {
        if (questionItem.questionOrder === questionOrder) {
          return {
            ...questionItem,
            questionOrder: questionItem.questionOrder,
            answer: primaryTextArea,
            starRatingTextBox: null,
            surveyQuestionId: questionItem?.surveyQuestionId || questionItem.id,
            questionText: questionItem.questionText,
            questionTypeId: questionItem.questionTypeId,
            isSentimentQuestion: questionItem.isSentimentQuestion,
            charLimit: questionItem.charLimit,
          };
        }
        return questionItem;
      });
      setCustomerQuestions(updatedQuestions);

      if (
        Array.isArray(questionArray) &&
        currentQuestion + 1 === questionArray.length
      ) {
        //Get the last object from the updatedQuestions array
        const lastObject = updatedQuestions[updatedQuestions.length - 1];

        //Check if the last object's answer is not an empty string
        if (
          lastObject?.answer?.trim() &&
          isAllStarRatingAnswersPositive?.() &&
          customerDetail?.googleSocialLink
        ) {
          copyToClipboard(lastObject.answer);
        }
        if (setSurveyCompleted) {
          setSurveyCompleted(true);
        }
        handleSubmitSurvey(updatedQuestions);
      }
      handleNextButton();
    }
  };

  //Copy comment to clipboard
  const copyToClipboard = (row) => {
    navigator.clipboard.writeText(row);
  };

  const handleBack = (event) => {
    event.preventDefault();
    handleBackButton();
  };

  const fieldName = `${questionOrder}-${question?.questionTypeId}-${
    question?.surveyQuestionId || question?.id
  }`;

  useEffect(() => {
    const value = question?.answer || emptyString;
    setPrimaryTextArea(value);
    setValue(fieldName, value);

    // eslint-disable-next-line
  }, [question]);

  if (!question) {
    return emptyString;
  }

  return (
    <Form onSubmit={handleSubmit(handleNext)}>
      <div className="d-flex flex-column question-container">
        <QuestionHeadingLogo brandDetail={brandDetail} />
        <CustomerInfoCard
          questionArray={questionArray}
          questionOrder={questionOrder}
          customerDetail={customerDetail}
        />
        <Row
          className={`justify-content-center ${
            questionOrder === FIRST_QUESTION_ORDER ? "pt-2 my-auto" : "pt-5"
          } mx-1`}
        >
          <Col md={5}>
            <h3
              className="text-center text-bold lh-base mx-3 question-text"
              aria-label={customerSurveyLabels.QUESTION_TEXT_ARIA}
            >
              {questionText}
            </h3>
          </Col>
        </Row>
        <div className="w-100 px-3 mt-3">
          <Row className="row mt-auto  justify-content-center">
            <Col md={8} className="mb-4">
              <Form.Control
                as="textarea"
                id="textarea"
                aria-label={customerSurveyLabels.PRIMARY_TEXTBOX_ARIA}
                className={`mb-1 bg-light textbox-textarea rounded border-0 ${
                  errors[fieldName] ? "is-invalid" : emptyString
                }`}
                name={fieldName}
                value={primaryTextArea}
                rows={TEXTAREA_ROWS}
                placeholder={customerSurveyLabels.ADD_COMMENTS_PLACEHOLDER}
                {...register(fieldName, {
                  onChange: (e) => setPrimaryTextArea(e.target.value),
                })}
              />
              <small
                className={`text-danger ${
                  primaryTextArea.length <= charLimit ? "d-none" : emptyString
                }`}
              >
                {customerSurveyLabels.getCharLimitExceededMessage(charLimit)}
              </small>
            </Col>
          </Row>
        </div>

        <NextButton
          handleBack={handleBack}
          handleNext={handleNext}
          questionNo={currentQuestion + 1}
          questionArray={questionArray}
          currentQuestion={currentQuestion}
        />
      </div>
    </Form>
  );
};

export default Textbox;
